import { SiteConfig } from './helpCenterResource';
import { DomainError } from '@ad-scripts/application/lib/error';

const validateSiteConfigAnswersCount = (siteConfig: SiteConfig) => {
  const uniqueAnswers = new Set();
  siteConfig.sections.forEach(section => {
    const answersInSection = section.answerIds;
    answersInSection.forEach(answerId => {
      uniqueAnswers.add(answerId);
    });
  });

  if (uniqueAnswers.size > 1000) {
    throw new DomainError([
      {
        attr: 'answerIds',
        code: 'greater_than',
        detail: `Help centers can have a maximum of 1000 unique answers. You have currently configured ${uniqueAnswers.size} answers. Please remove some answers and try again.`,
      },
    ]);
  }
};

export default validateSiteConfigAnswersCount;
